/* eslint camelcase: "off" */
import fetch from 'cross-fetch';

export async function getWistiaThumbnailUrl(videoId) {
    const apiUrl = `https://fast.wistia.net/oembed?url=http://home.wistia.com/medias/${videoId}?embedType=async_popover&videoWidth=900&popoverWidth=480&popoverHeight=360`;

    try {
        const response = await fetch(apiUrl);

        if (!response.ok) throw new Error(`Failed to fetch content from: ${apiUrl}`);

        const result = await response.json();

        return `${result.thumbnail_url}&image_resize=480`;
    } catch (error) {
        console.error(error);
        return null;
    }
}
